import Preferences from './preferences';

export default Preferences;